(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spacer-athletes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spacer-athletes-marquee')) {
    customElements.define('spacer-athletes-marquee', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-marquee-track]');
        this.original = this.querySelector('[data-original]');
        if (!this.original || !this.original.children.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.hovered = false;
        this.dragging = false;
        this.selected = false;
        this.visible = true;
        this.position = 0;
        this.lastWritten = 0;
        this.speed = Number(this.dataset.speed) || 40;
        this.sign = this.dataset.direction === 'right' ? -1 : 1;
        this.tick = this.tick.bind(this);
        this.viewport.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && this.dataset.hoverPause === 'true') this.hovered = true;
        }, options);
        this.viewport.addEventListener('pointerleave', () => { this.hovered = false; }, options);
        this.viewport.addEventListener('pointerdown', () => { this.dragging = true; }, options);
        const release = () => { this.dragging = false; this.resumeAt = performance.now() + 1500; };
        window.addEventListener('pointerup', release, options);
        window.addEventListener('pointercancel', release, options);
        this.viewport.addEventListener('wheel', () => { this.resumeAt = performance.now() + 1500; }, { ...options, passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          this.selected = true;
          const card = event.target.closest('.sp-athlete');
          if (card) this.viewport.scrollLeft += card.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.selected = false; }, options);
        this.motion.addEventListener('change', () => this.build(), options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else this.start();
        }, options);
        this.resize = new ResizeObserver(() => this.build());
        this.resize.observe(this.viewport);
        this.resize.observe(this.original);
        this.intersection = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          if (this.visible) this.start();
          else this.stop();
        });
        this.intersection.observe(this);
        this.build();
      }
      build() {
        this.stop();
        this.track.querySelectorAll('[data-copy]').forEach((copy) => copy.remove());
        this.distance = this.original.getBoundingClientRect().width;
        if (this.motion.matches || !this.distance) {
          this.viewport.scrollLeft = 0;
          return;
        }
        const copies = Math.ceil(this.viewport.clientWidth / this.distance) + 1;
        for (let index = 0; index < copies; index++) {
          const copy = this.original.cloneNode(true);
          copy.removeAttribute('data-original');
          copy.setAttribute('data-copy', '');
          copy.setAttribute('aria-hidden', 'true');
          [copy, ...copy.querySelectorAll('*')].forEach((element) => {
            element.removeAttribute('id');
            [...element.attributes].forEach((attribute) => {
              if (attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
            });
          });
          copy.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => element.setAttribute('tabindex', '-1'));
          copy.querySelectorAll('img').forEach((image) => { image.loading = 'eager'; });
          this.track.append(copy);
        }
        this.position = ((this.viewport.scrollLeft % this.distance) + this.distance) % this.distance;
        if (this.sign < 0 && this.position === 0) this.position = this.distance;
        this.viewport.scrollLeft = this.position;
        this.lastWritten = this.viewport.scrollLeft;
        this.start();
      }
      start() {
        if (this.frame || this.motion.matches || !this.distance || !this.visible || document.hidden) return;
        this.lastTime = null;
        this.frame = requestAnimationFrame(this.tick);
      }
      stop() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.lastTime = null;
      }
      tick(time) {
        const elapsed = this.lastTime === null ? 0 : Math.min(time - this.lastTime, 50);
        this.lastTime = time;
        const actual = this.viewport.scrollLeft;
        if (Math.abs(actual - this.lastWritten) > 1) this.position = actual;
        const focused = this.viewport.contains(document.activeElement);
        if (!this.hovered && !this.dragging && !this.selected && !focused && time >= (this.resumeAt || 0)) {
          this.position += this.sign * this.speed * elapsed / 1000;
          this.position = ((this.position % this.distance) + this.distance) % this.distance;
          this.viewport.scrollLeft = this.position;
        }
        this.lastWritten = this.viewport.scrollLeft;
        this.frame = requestAnimationFrame(this.tick);
      }
      disconnectedCallback() {
        this.stop();
        this.controller?.abort();
        this.resize?.disconnect();
        this.intersection?.disconnect();
        this.track?.querySelectorAll('[data-copy]').forEach((copy) => copy.remove());
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spacer-pdp-goals"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spacer-movement-goals')) {
  customElements.define('spacer-movement-goals', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.list = this.querySelector('[role="tablist"]');
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      if (!this.list || !this.tabs.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.select(index), options));
      this.list.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else if (event.key === (this.mobile.matches ? 'ArrowRight' : 'ArrowDown')) next = (index + 1) % this.tabs.length;
        else if (event.key === (this.mobile.matches ? 'ArrowLeft' : 'ArrowUp')) next = (index - 1 + this.tabs.length) % this.tabs.length;
        else return;
        event.preventDefault();
        this.tabs[next].focus({ preventScroll: true });
        this.select(next);
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[role="tabpanel"]');
        const index = this.panels.indexOf(panel);
        if (index >= 0) this.select(index, false);
      }, options);
      this.mobile.addEventListener('change', () => {
        this.orientation();
        this.reveal(false);
      }, options);
      this.setAttribute('data-ready', '');
      this.orientation();
      this.select(Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')), false);
    }
    orientation() {
      this.list.setAttribute('aria-orientation', this.mobile.matches ? 'horizontal' : 'vertical');
    }
    select(index, animate = true) {
      this.active = index;
      this.tabs.forEach((tab, current) => {
        const selected = current === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (this.panels[current]) this.panels[current].hidden = !selected;
      });
      this.reveal(animate);
    }
    reveal(animate) {
      if (!this.mobile.matches || !this.tabs[this.active]) return;
      const button = this.tabs[this.active].getBoundingClientRect();
      const viewport = this.list.getBoundingClientRect();
      const delta = button.left < viewport.left ? button.left - viewport.left : button.right > viewport.right ? button.right - viewport.right : 0;
      if (delta) this.list.scrollBy({ left: delta, behavior: animate && !this.reduced.matches ? 'smooth' : 'auto' });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spacer-pdp-main"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spacer-pdp-thumbnails')) {
  customElements.define('spacer-pdp-thumbnails', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-thumbnail-track]');
      this.previous = this.querySelector('[data-thumbnail-prev]');
      this.next = this.querySelector('[data-thumbnail-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.previous.addEventListener('click', () => this.page(-1), options);
      this.next.addEventListener('click', () => this.page(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('focusin', (event) => {
        const button = event.target.closest('[data-media-target]');
        if (button) this.reveal(button);
      }, options);
      this.track.addEventListener('keydown', (event) => {
        const buttons = [...this.track.querySelectorAll('[data-media-target]')];
        const current = buttons.indexOf(document.activeElement);
        if (current < 0) return;
        let target;
        if (event.key === 'ArrowRight') target = Math.min(current + 1, buttons.length - 1);
        else if (event.key === 'ArrowLeft') target = Math.max(current - 1, 0);
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = buttons.length - 1;
        else return;
        event.preventDefault();
        buttons[target].focus({ preventScroll: true });
        this.reveal(buttons[target]);
      }, options);
      this.observer = new MutationObserver(() => {
        const active = this.track.querySelector('[aria-pressed="true"]');
        if (active) this.reveal(active);
        this.update();
      });
      this.observer.observe(this.track, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'], childList: true });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this);
      this.resize.observe(this.track);
      this.update();
      this.initialFrame = requestAnimationFrame(() => {
        const active = this.track.querySelector('[aria-pressed="true"]');
        if (active) this.reveal(active, false);
      });
    }
    page(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth * 0.8, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
    }
    reveal(button, animate = true) {
      const viewport = this.track.getBoundingClientRect();
      const item = button.getBoundingClientRect();
      let offset = 0;
      if (item.left < viewport.left + 2) offset = item.left - viewport.left - 2;
      else if (item.right > viewport.right - 2) offset = item.right - viewport.right + 2;
      if (offset) this.track.scrollBy({ left: offset, behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'auto' });
    }
    update() {
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.previous.hidden = !hasOverflow;
      this.next.hidden = !hasOverflow;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      cancelAnimationFrame(this.initialFrame);
      this.controller = null;
    }
  });
}
if (!customElements.get('spacer-pdp-gallery')) {
  customElements.define('spacer-pdp-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.stage = this.querySelector('.sp-pdp-gallery__stage');
      if (!this.stage) return;
      this.slides = [...this.stage.querySelectorAll(':scope > .sp-pdp-media')];
      if (!this.slides.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.navigation = this.querySelector('[data-gallery-navigation]');
      this.previous = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.counter = this.querySelector('[data-gallery-counter]');
      this.active = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
      this.dataset.hasMany = String(this.slides.length > 1);
      this.previous?.addEventListener('click', () => this.select(this.active - 1), options);
      this.next?.addEventListener('click', () => this.select(this.active + 1), options);
      this.addEventListener('click', (event) => {
        if (!this.mobile.matches) return;
        const thumbnail = event.target.closest('[data-media-target]');
        if (!thumbnail || !this.contains(thumbnail)) return;
        const index = this.slides.findIndex((slide) => slide.dataset.mediaId === thumbnail.dataset.mediaTarget);
        if (index < 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.select(index);
      }, { ...options, capture: true });
      this.stage.addEventListener('keydown', (event) => {
        if (!this.mobile.matches || event.target !== this.stage) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.select(this.active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.stage.addEventListener('scroll', () => {
        if (!this.mobile.matches) return;
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.settle(), 140);
      }, { ...options, passive: true });
      this.mobile.addEventListener('change', () => this.applyMode(), options);
      this.mediaObserver = new MutationObserver(() => {
        if (this.stage !== this.querySelector('.sp-pdp-gallery__stage') || this.slides.length !== this.stage.querySelectorAll(':scope > .sp-pdp-media').length) {
          this.disconnectedCallback();
          this.connectedCallback();
          return;
        }
        const activeSlide = this.slides.findIndex((slide) => !slide.hidden);
        if (activeSlide >= 0 && activeSlide !== this.active) {
          this.active = activeSlide;
          this.setState();
          if (this.mobile.matches) this.align(false);
        }
      });
      this.observeMedia();
      this.resize = new ResizeObserver(() => {
        const width = this.stage.clientWidth;
        if (width !== this.lastWidth) {
          this.lastWidth = width;
          if (this.mobile.matches) this.align(false);
        }
      });
      this.resize.observe(this.stage);
      this.applyMode();
    }
    observeMedia() {
      this.mediaObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-pressed'] });
    }
    applyMode() {
      clearTimeout(this.scrollTimer);
      this.classList.toggle('sp-mobile-ready', this.mobile.matches);
      if (this.mobile.matches) this.stage.setAttribute('tabindex', '0');
      else this.stage.removeAttribute('tabindex');
      this.setState();
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => {
        if (this.mobile.matches) this.align(false);
        else this.stage.scrollLeft = 0;
      });
    }
    select(index) {
      this.active = Math.max(0, Math.min(index, this.slides.length - 1));
      this.setState();
      this.align(true);
    }
    align(animate) {
      if (!this.mobile.matches || !this.slides[this.active]) return;
      const slide = this.slides[this.active];
      const left = this.stage.scrollLeft + slide.getBoundingClientRect().left - this.stage.getBoundingClientRect().left;
      this.stage.scrollTo({ left, behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'auto' });
    }
    settle() {
      if (!this.isConnected || !this.mobile.matches) return;
      const left = this.stage.getBoundingClientRect().left;
      let nearest = this.active;
      let distance = Infinity;
      this.slides.forEach((slide, index) => {
        const delta = Math.abs(slide.getBoundingClientRect().left - left);
        if (delta < distance) { distance = delta; nearest = index; }
      });
      if (nearest !== this.active) {
        this.active = nearest;
        this.setState();
      }
    }
    setState() {
      this.mediaObserver.disconnect();
      const activeId = this.slides[this.active]?.dataset.mediaId;
      this.slides.forEach((slide, index) => {
        const selected = index === this.active;
        slide.hidden = !selected;
        if (this.mobile.matches) {
          slide.inert = !selected;
          slide.setAttribute('aria-hidden', String(!selected));
        } else {
          slide.inert = false;
          slide.removeAttribute('aria-hidden');
        }
        if (!selected) slide.querySelectorAll('video').forEach((video) => video.pause());
        slide.querySelectorAll('iframe').forEach((frame) => {
          if (!selected && !frame.dataset.spPausedSrc && frame.getAttribute('src')) {
            frame.dataset.spPausedSrc = frame.getAttribute('src');
            frame.setAttribute('src', 'about:blank');
          } else if (selected && frame.dataset.spPausedSrc) {
            frame.setAttribute('src', frame.dataset.spPausedSrc);
            delete frame.dataset.spPausedSrc;
          }
        });
      });
      this.querySelectorAll('[data-media-target]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === activeId));
      });
      if (this.navigation) this.navigation.hidden = !this.mobile.matches || this.slides.length < 2;
      if (this.previous) this.previous.disabled = this.active === 0;
      if (this.next) this.next.disabled = this.active === this.slides.length - 1;
      if (this.counter) this.counter.textContent = `${this.active + 1} / ${this.slides.length}`;
      this.observeMedia();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.mediaObserver?.disconnect();
      this.resize?.disconnect();
      clearTimeout(this.scrollTimer);
      cancelAnimationFrame(this.layoutFrame);
      this.controller = null;
    }
  });
}

if (!customElements.get('spacer-pdp-quantity')) {
  customElements.define('spacer-pdp-quantity', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.input = this.querySelector('input[name="quantity"]');
      this.minus = this.querySelector('[data-quantity-minus]');
      this.plus = this.querySelector('[data-quantity-plus]');
      if (!this.input || !this.minus || !this.plus) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.minus.addEventListener('click', () => this.adjust(-1), options);
      this.plus.addEventListener('click', () => this.adjust(1), options);
      this.input.addEventListener('input', () => this.update(), options);
      this.input.addEventListener('change', () => this.normalize(), options);
      this.observer = new MutationObserver(() => this.normalize());
      this.observer.observe(this.input, { attributes: true, attributeFilter: ['min', 'max', 'step', 'disabled', 'readonly', 'value'] });
      this.update();
    }
    limits() {
      const min = Math.max(1, Number(this.input.min) || 1);
      const step = Math.max(1, Number(this.input.step) || 1);
      const rawMax = this.input.getAttribute('max');
      const cap = rawMax === null || rawMax === '' ? Infinity : Number(rawMax);
      const max = Number.isFinite(cap) ? min + Math.floor((cap - min) / step) * step : Infinity;
      return { min, step, max };
    }
    adjust(direction) {
      if (this.input.disabled || this.input.readOnly) return;
      const { min, step, max } = this.limits();
      if (max < min) return;
      const value = this.input.valueAsNumber;
      const next = Number.isFinite(value)
        ? min + (direction > 0 ? Math.floor((value - min) / step) + 1 : Math.ceil((value - min) / step) - 1) * step
        : min;
      this.commit(Math.min(max, Math.max(min, next)), true);
    }
    normalize() {
      const { min, step, max } = this.limits();
      if (max < min || this.input.disabled || this.input.readOnly) { this.update(); return; }
      const value = this.input.valueAsNumber;
      const normalized = Number.isFinite(value) ? min + Math.round((value - min) / step) * step : min;
      this.commit(Math.min(max, Math.max(min, normalized)), false);
    }
    commit(value, notifyChange) {
      const changed = this.input.value !== String(value);
      this.input.value = String(value);
      this.update();
      if (changed) this.input.dispatchEvent(new Event('input', { bubbles: true }));
      if (notifyChange && changed) this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    update() {
      const { min, max } = this.limits();
      const value = this.input.valueAsNumber;
      const locked = this.input.disabled || this.input.readOnly || max < min;
      this.minus.disabled = locked || Number.isFinite(value) && value <= min;
      this.plus.disabled = locked || Number.isFinite(value) && value >= max;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}

if (!customElements.get('spacer-pdp-total')) {
  customElements.define('spacer-pdp-total', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.root = this.closest('[data-sp-product-root]');
      this.form = this.closest('form');
      if (!this.root || !this.form) return;
      this.controller = new AbortController();
      this.prices = new Map();
      const options = { signal: this.controller.signal };
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateTotal());
      };
      this.root.addEventListener('input', (event) => {
        if (event.target.matches('[name="quantity"], [data-variant-input]')) schedule();
      }, options);
      this.root.addEventListener('change', schedule, options);
      this.observer = new MutationObserver((records) => {
        if (records.some((record) => {
          const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          return target === this.root || target?.closest('.sp-pdp-form, .sp-pdp-price');
        })) schedule();
      });
      this.observer.observe(this.root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value', 'min', 'max', 'step', 'disabled', 'aria-disabled', 'aria-busy', 'data-variant-id', 'data-unit-price', 'data-price-variant-id'] });
      this.updateTotal();
    }
    formatMoney(cents) {
      const example = this.dataset.moneyExample;
      const match = example?.match(/[0-9][0-9\s.,'’]*[0-9]/);
      if (!match) return new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
      const number = match[0];
      const decimal = number.match(/([.,])89$/);
      const decimals = decimal ? 2 : 0;
      const integer = decimal ? number.slice(0, -3) : number;
      const group = integer.replace(/[0-9]/g, '').charAt(0);
      const parts = (cents / 100).toFixed(decimals).split('.');
      if (group) parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group);
      const formatted = parts[0] + (decimal ? decimal[1] + parts[1] : '');
      return example.slice(0, match.index) + formatted + example.slice(match.index + number.length);
    }
    updateTotal() {
      const button = this.querySelector('.sp-pdp-add');
      const quantityInput = this.form.querySelector('[name="quantity"]');
      const variantInput = this.form.querySelector('[data-variant-input]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true' || button.classList.contains('loading') || button.getAttribute('aria-busy') === 'true' || this.form.getAttribute('aria-busy') === 'true') return;
      const variantId = variantInput?.value || this.root.dataset.variantId;
      if (!variantId) return;
      const price = this.root.querySelector('[data-current-price][data-unit-price]');
      const sources = [this.dataset, price?.dataset];
      sources.forEach((source) => {
        const id = source?.priceVariantId || source?.variantId;
        if (id && source.unitPrice !== undefined && source.unitPrice !== '' && Number.isFinite(Number(source.unitPrice))) this.prices.set(id, Number(source.unitPrice));
      });
      const quantity = Number(quantityInput?.value);
      if (!Number.isInteger(quantity) || quantity < 1 || quantityInput?.validity?.valid === false) return;
      if (!this.prices.has(variantId)) { this.loadPrice(variantId); return; }
      const total = this.prices.get(variantId) * quantity;
      const label = `${this.dataset.addLabel} — ${this.formatMoney(total)}`;
      const labelElement = button.querySelector('[data-sp-add-label]');
      if (labelElement && labelElement.textContent !== label) labelElement.textContent = label;
    }
    async loadPrice(variantId) {
      if (this.pendingVariant === variantId || this.failedVariant === variantId) return;
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      this.pendingVariant = variantId;
      try {
        const url = new URL(this.root.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', variantId);
        url.searchParams.set('section_id', this.root.dataset.sectionId);
        const response = await fetch(url, { signal: request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Could not refresh variant price');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = document.querySelector('spacer-pdp-total');
        if (source?.dataset.variantId !== variantId || source.dataset.unitPrice === '' || !Number.isFinite(Number(source.dataset.unitPrice))) throw new Error('Variant price unavailable');
        if (request.signal.aborted || !this.isConnected) return;
        this.prices.set(variantId, Number(source.dataset.unitPrice));
        this.updateTotal();
      } catch (error) {
        if (error.name !== 'AbortError') this.failedVariant = variantId;
      } finally {
        if (this.request === request) this.pendingVariant = null;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.request?.abort();
      cancelAnimationFrame(this.frame);
      this.controller = null;
    }
  });
}

if (!customElements.get('spacer-pdp-sticky-cart-v3')) {
  customElements.define('spacer-pdp-sticky-cart-v3', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.startFrame) return;
      this.startFrame = requestAnimationFrame(() => {
        this.startFrame = null;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      if (this.controller) return;
      this.section = this.closest('.sp-pdp-main');
      this.bar = this.querySelector('[data-sticky-cart-bar]');
      this.button = this.bar?.querySelector('[data-sticky-cart-button]');
      if (!this.section || !this.bar || !this.button) {
        if (!this.pendingObserver) {
          this.pendingObserver = new MutationObserver(() => this.initialize());
          this.pendingObserver.observe(this, { childList: true, subtree: true });
        }
        return;
      }
      this.pendingObserver?.disconnect();
      this.pendingObserver = null;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.titleElement = this.bar.querySelector('[data-sticky-cart-title]');
      this.summary = this.bar.querySelector('[data-sticky-cart-summary]');
      this.defaultLabel = this.button.textContent.trim();
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.spacer = document.createElement('div');
      this.spacer.className = 'sp-pdp-sticky-cart__spacer';
      this.spacer.setAttribute('aria-hidden', 'true');
      document.body.append(this.bar, this.spacer);
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (this.isConnected) this.sync();
        });
      };
      window.addEventListener('scroll', this.schedule, { ...options, passive: true, capture: true });
      window.addEventListener('resize', this.schedule, options);
      window.addEventListener('pageshow', this.schedule, options);
      this.section.addEventListener('input', this.schedule, options);
      this.section.addEventListener('change', this.schedule, options);
      this.section.addEventListener('submit', this.schedule, options);
      this.mobile.addEventListener('change', this.schedule, options);
      this.button.addEventListener('click', () => this.submitOriginal(), options);
      this.sourceObserver = new MutationObserver(this.schedule);
      this.sourceObserver.observe(this.section, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'value', 'data-variant-id', 'hidden', 'class', 'style'] });
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this.section);
      this.resize.observe(this.bar);
      this.sync();
    }
    refreshSource() {
      this.root = this.section.querySelector('[data-sp-product-root]');
      this.main = this.root?.querySelector('button.sp-pdp-add') || this.section.querySelector('form[action*="/cart/add"] button[name="add"]');
    }
    viewportState() {
      if (!this.main) return { rendered: false, visible: false };
      const rect = this.main.getBoundingClientRect();
      const style = getComputedStyle(this.main);
      const rendered = rect.width > 0 && rect.height > 0 && this.main.getClientRects().length > 0 && style.visibility !== 'hidden' && style.display !== 'none';
      const visible = rendered && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      return { rendered, visible };
    }
    sync() {
      this.refreshSource();
      if (!this.main) { this.setVisible(false); return; }
      const form = this.main.form || this.main.closest('form');
      const title = this.root?.querySelector('h1')?.textContent.trim();
      if (title && this.titleElement && this.titleElement.textContent !== title) this.titleElement.textContent = title;
      const label = (this.main.querySelector('[data-sp-add-label]') || this.main).textContent.trim() || this.defaultLabel;
      if (this.button.textContent !== label) this.button.textContent = label;
      const busy = this.main.classList.contains('loading') || this.main.getAttribute('aria-busy') === 'true' || form?.getAttribute('aria-busy') === 'true';
      this.button.disabled = this.main.disabled || this.main.getAttribute('aria-disabled') === 'true' || busy;
      this.button.setAttribute('aria-busy', String(busy));
      const parts = [...(this.root?.querySelectorAll('.sp-pdp-options legend') || [])].map((legend) => legend.textContent.replace(/\s+/g, ' ').trim()).filter(Boolean);
      const quantity = form?.querySelector('[name="quantity"]')?.value;
      if (quantity && Number(quantity) > 0) parts.push(`${this.dataset.quantityLabel}: ${quantity}`);
      const summary = parts.join(' · ');
      if (this.summary.textContent !== summary) this.summary.textContent = summary;
      this.summary.hidden = !summary;
      const enabled = this.mobile.matches ? this.dataset.mobile !== 'false' : this.dataset.desktop !== 'false';
      const state = this.viewportState();
      this.mainVisible = state.visible;
      this.setVisible(enabled && state.rendered && !state.visible);
    }
    setVisible(show) {
      if (!show && this.bar.contains(document.activeElement) && this.mainVisible && this.main) this.main.focus({ preventScroll: true });
      this.bar.hidden = !show;
      const height = show ? `${this.bar.getBoundingClientRect().height}px` : '0px';
      if (this.spacer.style.height !== height) this.spacer.style.height = height;
    }
    submitOriginal() {
      this.refreshSource();
      if (!this.main || this.main.disabled || this.main.getAttribute('aria-disabled') === 'true' || this.main.getAttribute('aria-busy') === 'true' || this.main.form?.getAttribute('aria-busy') === 'true') return;
      this.button.disabled = true;
      this.main.click();
      this.schedule();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.sourceObserver?.disconnect();
      this.pendingObserver?.disconnect();
      this.resize?.disconnect();
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.frame);
      if (this.bar) {
        this.bar.hidden = true;
        this.append(this.bar);
      }
      this.spacer?.remove();
      this.controller = null;
      this.pendingObserver = null;
      this.startFrame = null;
      this.frame = null;
      this.main = null;
      this.root = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spacer-pdp-modes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spacer-board-modes')) {
  customElements.define('spacer-board-modes', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-modes-track]');
      this.cards = [...this.querySelectorAll('.sp-pdp-mode')];
      this.controls = this.querySelector('[data-modes-controls]');
      this.previous = this.querySelector('[data-modes-prev]');
      this.next = this.querySelector('[data-modes-next]');
      this.counter = this.querySelector('[data-modes-counter]');
      if (!this.track || !this.cards.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.active = 0;
      this.previous.addEventListener('click', () => this.go(this.active - 1), options);
      this.next.addEventListener('click', () => this.go(this.active + 1), options);
      this.track.addEventListener('scroll', () => {
        if (!this.mobile.matches) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.settle(), 120);
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (!this.mobile.matches || event.target !== this.track) return;
        let index;
        if (event.key === 'ArrowRight') index = this.active + 1;
        else if (event.key === 'ArrowLeft') index = this.active - 1;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.cards.length - 1;
        else return;
        event.preventDefault();
        this.go(index);
      }, options);
      this.track.addEventListener('focusin', (event) => {
        const index = this.cards.indexOf(event.target.closest('.sp-pdp-mode'));
        if (this.mobile.matches && index >= 0) this.go(index, false);
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.cards.indexOf(event.target.closest('.sp-pdp-mode'));
        if (this.mobile.matches && index >= 0) this.go(index, false);
      }, options);
      this.mobile.addEventListener('change', () => this.layout(), options);
      this.resize = new ResizeObserver(() => {
        const width = this.track.clientWidth;
        if (width !== this.lastWidth) { this.lastWidth = width; this.layout(); }
      });
      this.resize.observe(this.track);
      this.layout();
    }
    layout() {
      clearTimeout(this.timer);
      this.controls.hidden = !this.mobile.matches || this.cards.length < 2;
      if (this.mobile.matches && this.cards.length > 1) this.track.setAttribute('tabindex', '0');
      else this.track.removeAttribute('tabindex');
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        if (this.mobile.matches) this.go(this.active, false);
        else this.track.scrollLeft = 0;
      });
    }
    go(index, animate = true) {
      if (!this.mobile.matches) return;
      this.active = Math.max(0, Math.min(index, this.cards.length - 1));
      const left = this.track.scrollLeft + this.cards[this.active].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({ left, behavior: animate && !this.reduced.matches ? 'smooth' : 'auto' });
      this.update();
    }
    settle() {
      if (!this.mobile.matches || !this.isConnected) return;
      const left = this.track.getBoundingClientRect().left;
      let nearest = 0;
      let distance = Infinity;
      this.cards.forEach((card, index) => {
        const delta = Math.abs(card.getBoundingClientRect().left - left);
        if (delta < distance) { distance = delta; nearest = index; }
      });
      this.active = nearest;
      this.update();
    }
    update() {
      this.previous.disabled = this.active === 0;
      this.next.disabled = this.active === this.cards.length - 1;
      const text = `${this.active + 1} / ${this.cards.length}`;
      if (this.counter.textContent !== text) this.counter.textContent = text;
      this.cards.forEach((card, index) => {
        if (index !== this.active) card.querySelectorAll('video').forEach((video) => video.pause());
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resize?.disconnect();
      clearTimeout(this.timer);
      cancelAnimationFrame(this.frame);
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
